/**
 * @generated SignedSource<<41acdcef6d95131af25323b68dccd607>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityType = "CLIENT_FORM" | "MEAL_LOGGING" | "NUTRITION_TARGET" | "PROGRAM_COMPONENT" | "%future added value";
export type MessageDirection = "INCOMING" | "OUTGOING" | "%future added value";
export type useLiveUpdatesQuery$variables = {
  id: string;
};
export type useLiveUpdatesQuery$data = {
  readonly me: {
    readonly notificationUnreadCount: number;
    readonly notificationsActive: boolean;
    readonly unreadMessagesCounter: number;
  } | null | undefined;
  readonly node: {
    readonly __typename: string;
    readonly activity?: {
      readonly id: string;
    };
    readonly activityFeedback?: {
      readonly activity: {
        readonly clientForm: {
          readonly formattedDate: string | null | undefined;
          readonly name: string;
          readonly slug: string;
        } | null | undefined;
        readonly component: {
          readonly program: {
            readonly name: string;
            readonly slug: string;
          };
          readonly slug: string;
          readonly title: string;
        } | null | undefined;
        readonly date: string | null | undefined;
        readonly type: ActivityType;
      };
      readonly content: string;
      readonly formattedDate: string | null | undefined;
    } | null | undefined;
    readonly activityFeedbackId?: string;
    readonly author?: {
      readonly displayName: string | null | undefined;
      readonly id?: string;
      readonly photoURL: string | null | undefined;
      readonly username: string;
    };
    readonly clientForm?: {
      readonly formattedDate: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly slug: string;
    } | null | undefined;
    readonly content?: string;
    readonly createdAt?: string | null | undefined;
    readonly deleted?: boolean | null | undefined;
    readonly direction?: MessageDirection;
    readonly formattedDate?: string | null | undefined;
    readonly groupComment?: {
      readonly author: {
        readonly displayName: string | null | undefined;
        readonly photoURL: string | null | undefined;
        readonly username: string;
      };
      readonly content: string;
      readonly formattedDate: string | null | undefined;
      readonly groupPost: {
        readonly group: {
          readonly name: string;
          readonly slug: string;
        };
        readonly title: string | null | undefined;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly groupId?: string;
    readonly groupPost?: {
      readonly author: {
        readonly displayName: string | null | undefined;
        readonly photoURL: string | null | undefined;
        readonly username: string;
      };
      readonly content: string;
      readonly formattedDate: string | null | undefined;
      readonly group: {
        readonly name: string;
        readonly slug: string;
      };
      readonly id: string;
      readonly title: string | null | undefined;
    } | null | undefined;
    readonly groupPostId?: string;
    readonly id: string;
    readonly message?: {
      readonly author: {
        readonly displayName: string | null | undefined;
        readonly photoURL: string | null | undefined;
        readonly username: string;
      };
      readonly content: string;
      readonly formattedDate: string | null | undefined;
      readonly id: string;
      readonly notified: boolean;
    } | null | undefined;
    readonly read?: boolean;
    readonly thread?: {
      readonly author: {
        readonly displayName: string | null | undefined;
        readonly id: string;
        readonly photoURL: string | null | undefined;
      } | null | undefined;
      readonly content: string;
      readonly formattedDate: string | null | undefined;
      readonly group: {
        readonly name: string;
      } | null | undefined;
      readonly id: string;
      readonly read: boolean;
      readonly slug: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"GroupPostCommentsListItem_comment" | "GroupPostsListItem_post">;
  } | null | undefined;
};
export type useLiveUpdatesQuery = {
  response: useLiveUpdatesQuery$data;
  variables: useLiveUpdatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadMessagesCounter",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationUnreadCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationsActive",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityFeedbackId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  (v13/*: any*/),
  (v15/*: any*/)
],
v17 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  }
],
v18 = {
  "alias": "formattedDate",
  "args": (v17/*: any*/),
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": "updatedAt(format:\"MMM DD, YYYY\")"
},
v19 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v20 = {
  "alias": null,
  "args": (v19/*: any*/),
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(raw:true)"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v22 = {
  "alias": "formattedDate",
  "args": (v17/*: any*/),
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"MMM DD, YYYY\")"
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Group",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notified",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientForm",
  "kind": "LinkedField",
  "name": "clientForm",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v15/*: any*/),
    (v13/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
},
v28 = {
  "alias": "formattedDate",
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "dddd DD MMM yyyy"
    }
  ],
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"dddd DD MMM yyyy\")"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v30 = {
  "alias": "formattedDate",
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "D MMM"
    }
  ],
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": "updatedAt(format:\"D MMM\")"
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": (v19/*: any*/),
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": "displayName(raw:true)"
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "fromNow"
    }
  ],
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"fromNow\")"
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/),
    (v21/*: any*/),
    (v27/*: any*/),
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Activity",
      "kind": "LinkedField",
      "name": "activity",
      "plural": false,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ActivityFeedback",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupPostId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v38 = [
  (v13/*: any*/),
  (v15/*: any*/),
  (v5/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Group",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 5
  }
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootParentCommentId",
  "storageKey": null
},
v42 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 3
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Notification",
  "kind": "LinkedField",
  "name": "notification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    (v27/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v45 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 1
  }
],
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v45/*: any*/),
      "concreteType": "LikeConnection",
      "kind": "LinkedField",
      "name": "likes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LikeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Like",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v32/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            (v46/*: any*/)
          ],
          "storageKey": null
        },
        (v47/*: any*/)
      ],
      "storageKey": "likes(last:1)"
    },
    {
      "alias": null,
      "args": (v45/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "LikesList_likes",
      "kind": "LinkedHandle",
      "name": "likes"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likedByMe",
      "storageKey": null
    }
  ],
  "type": "Likeable",
  "abstractKey": "__isLikeable"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLiveUpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityFeedback",
                "kind": "LinkedField",
                "name": "activityFeedback",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Component",
                        "kind": "LinkedField",
                        "name": "component",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Program",
                            "kind": "LinkedField",
                            "name": "program",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientForm",
                        "kind": "LinkedField",
                        "name": "clientForm",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPost",
                "kind": "LinkedField",
                "name": "groupPost",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/),
                  (v10/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "message",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/),
                  (v10/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPostComment",
                "kind": "LinkedField",
                "name": "groupComment",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupPost",
                    "kind": "LinkedField",
                    "name": "groupPost",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "type": "Notification",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v21/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "thread",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v30/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Message",
            "abstractKey": null
          },
          (v34/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GroupPostsListItem_post"
              },
              (v35/*: any*/)
            ],
            "type": "GroupPost",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GroupPostCommentsListItem_comment"
              },
              (v36/*: any*/)
            ],
            "type": "GroupPostComment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLiveUpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v37/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityFeedback",
                "kind": "LinkedField",
                "name": "activityFeedback",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Component",
                        "kind": "LinkedField",
                        "name": "component",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Program",
                            "kind": "LinkedField",
                            "name": "program",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientForm",
                        "kind": "LinkedField",
                        "name": "clientForm",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPost",
                "kind": "LinkedField",
                "name": "groupPost",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/),
                  (v37/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "message",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/),
                  (v37/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupPostComment",
                "kind": "LinkedField",
                "name": "groupComment",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupPost",
                    "kind": "LinkedField",
                    "name": "groupPost",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v39/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "type": "Notification",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v21/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "thread",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v21/*: any*/),
                  (v30/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Message",
            "abstractKey": null
          },
          (v34/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v40/*: any*/),
                "concreteType": "GroupPostCommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupPostCommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GroupPostComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v41/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "concreteType": "GroupPostCommentConnection",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GroupPostCommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GroupPostComment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v41/*: any*/),
                                      (v21/*: any*/),
                                      (v43/*: any*/),
                                      (v33/*: any*/),
                                      (v44/*: any*/),
                                      (v6/*: any*/),
                                      (v48/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v47/*: any*/)
                            ],
                            "storageKey": "replies(last:3)"
                          },
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "GroupPostCommentsListItem_replies",
                            "kind": "LinkedHandle",
                            "name": "replies"
                          },
                          (v43/*: any*/),
                          (v33/*: any*/),
                          (v44/*: any*/),
                          (v6/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v47/*: any*/)
                ],
                "storageKey": "comments(last:5)"
              },
              {
                "alias": null,
                "args": (v40/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GroupPostCommentsList_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              },
              (v14/*: any*/),
              (v21/*: any*/),
              (v35/*: any*/),
              (v33/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v48/*: any*/)
            ],
            "type": "GroupPost",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v41/*: any*/),
              (v21/*: any*/),
              (v43/*: any*/),
              (v33/*: any*/),
              (v44/*: any*/),
              (v36/*: any*/),
              (v48/*: any*/)
            ],
            "type": "GroupPostComment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6412445681cc780ef45e94ece30b4054",
    "id": null,
    "metadata": {},
    "name": "useLiveUpdatesQuery",
    "operationKind": "query",
    "text": "query useLiveUpdatesQuery(\n  $id: ID!\n) {\n  me {\n    unreadMessagesCounter\n    notificationUnreadCount\n    notificationsActive\n    id\n  }\n  node(id: $id) {\n    id\n    __typename\n    ... on Notification {\n      id\n      author {\n        username\n        displayName\n        photoURL\n        id\n      }\n      activityFeedbackId\n      activityFeedback {\n        activity {\n          type\n          component {\n            slug\n            title\n            program {\n              slug\n              name\n              id\n            }\n            id\n          }\n          clientForm {\n            name\n            slug\n            formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n            id\n          }\n          date(raw: true)\n          id\n        }\n        content\n        formattedDate: createdAt(format: \"MMM DD, YYYY\")\n        id\n      }\n      groupPost {\n        id\n        content\n        title\n        formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n        author {\n          username\n          displayName\n          photoURL\n          id\n        }\n        group {\n          slug\n          name\n          id\n        }\n      }\n      message {\n        id\n        content\n        formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n        author {\n          username\n          displayName\n          photoURL\n          id\n        }\n        notified\n      }\n      groupComment {\n        id\n        content\n        formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n        author {\n          username\n          displayName\n          photoURL\n          id\n        }\n        groupPost {\n          title\n          group {\n            slug\n            name\n            id\n          }\n          id\n        }\n      }\n      clientForm {\n        id\n        name\n        slug\n        formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n      }\n      deleted\n      read\n    }\n    ... on Message {\n      id\n      content\n      formattedDate: createdAt(format: \"dddd DD MMM yyyy\")\n      direction\n      author {\n        displayName\n        photoURL\n        id\n      }\n      thread {\n        id\n        content\n        formattedDate: updatedAt(format: \"D MMM\")\n        read\n        slug\n        author {\n          id\n          displayName(raw: true)\n          photoURL\n        }\n        group {\n          name\n          id\n        }\n      }\n    }\n    ... on ActivityFeedback {\n      id\n      author {\n        id\n        displayName\n        photoURL\n      }\n      content\n      read\n      createdAt(format: \"fromNow\")\n      activity {\n        id\n      }\n    }\n    ... on GroupPost {\n      ...GroupPostsListItem_post\n      groupId\n    }\n    ... on GroupPostComment {\n      ...GroupPostCommentsListItem_comment\n      groupPostId\n    }\n  }\n}\n\nfragment Avatar_user on User {\n  displayName\n  photoURL\n}\n\nfragment GroupMemberBadges_user on User {\n  role\n}\n\nfragment GroupPostCommentsListItemNoReplies_comment on GroupPostComment {\n  ...GroupPostCommentsListItem_comment_3Tq2Ec\n}\n\nfragment GroupPostCommentsListItemWithReplies_comment on GroupPostComment {\n  ...GroupPostCommentsListItem_comment_ePDSa\n}\n\nfragment GroupPostCommentsListItem_comment on GroupPostComment {\n  ...Likeable_likeable\n  ...GroupPostsCommentForm_comment\n  id\n  content\n  notification {\n    userId\n    read\n    id\n  }\n  createdAt(format: \"fromNow\")\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    displayName\n    role\n    id\n  }\n}\n\nfragment GroupPostCommentsListItem_comment_3Tq2Ec on GroupPostComment {\n  ...Likeable_likeable\n  ...GroupPostsCommentForm_comment\n  id\n  content\n  notification {\n    userId\n    read\n    id\n  }\n  createdAt(format: \"fromNow\")\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    displayName\n    role\n    id\n  }\n}\n\nfragment GroupPostCommentsListItem_comment_ePDSa on GroupPostComment {\n  ...Likeable_likeable\n  ...GroupPostsCommentForm_comment\n  id\n  content\n  replies(last: 3) {\n    edges {\n      node {\n        id\n        ...GroupPostCommentsListItemNoReplies_comment\n        ...GroupPostsCommentForm_comment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  notification {\n    userId\n    read\n    id\n  }\n  createdAt(format: \"fromNow\")\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    displayName\n    role\n    id\n  }\n}\n\nfragment GroupPostCommentsList_post on GroupPost {\n  id\n  comments(last: 5) {\n    edges {\n      node {\n        ...GroupPostCommentsListItemWithReplies_comment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment GroupPostMenu_post on GroupPost {\n  ...GroupPostsEditDialog_post\n  id\n  groupId\n}\n\nfragment GroupPostsCommentForm_comment on GroupPostComment {\n  id\n  rootParentCommentId\n}\n\nfragment GroupPostsCommentForm_post on GroupPost {\n  id\n}\n\nfragment GroupPostsEditDialog_post on GroupPost {\n  id\n  title\n  content\n}\n\nfragment GroupPostsListItem_post on GroupPost {\n  ...GroupPostsCommentForm_post\n  ...GroupPostCommentsList_post\n  ...Likeable_likeable\n  ...GroupPostMenu_post\n  id\n  title\n  content\n  createdAt(format: \"fromNow\")\n  groupId\n  notification {\n    userId\n    read\n    id\n  }\n  author {\n    ...Avatar_user\n    ...GroupMemberBadges_user\n    id\n    role\n    displayName\n  }\n}\n\nfragment LikeListItem_like on Like {\n  author {\n    id\n    ...Avatar_user\n  }\n}\n\nfragment Likeable_likeable on Likeable {\n  __isLikeable: __typename\n  ...LikesList_likeable\n  ...LikesButton_likeable\n}\n\nfragment LikesButton_likeable on Likeable {\n  __isLikeable: __typename\n  id\n  likedByMe\n}\n\nfragment LikesList_likeable on Likeable {\n  __isLikeable: __typename\n  likes(last: 1) {\n    totalCount\n    edges {\n      node {\n        ...LikeListItem_like\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "63e0f3250096b5cb1c1e7e665e41effe";

export default node;
